import { Filter } from 'common/repositories/common.model';
import React from 'react';

import useFilterHandleTransformer from './use-filter-handle-transformer';

export type FilterHandleComponentContextType = {
  filters: Filter[];
  setFilters: React.Dispatch<React.SetStateAction<Filter[]>>;
  onClearFilters: (filters?: Filter[]) => void;
  onClearFilter: (name: string) => () => void;
  onChangeFilters: (filters: Filter[]) => void;
  onChangeFilter: (name: string, value: any) => void;
  onSelected: (name: string) => (value: any) => void;
  onGetSelectedFilter: (name: string) => Filter | undefined;
  onSyncFilters: (filters: Filter[]) => void;
  filtersHasValues: boolean;
  onCheckFiltersHasValues: (_filters?: Filter[]) => boolean;
  isUseResponseOptions: boolean;
};

const FilterHandleComponentContext =
  React.createContext<FilterHandleComponentContextType>({
    filters: [],
    setFilters(_) {},
    onChangeFilter(name, value) {},
    onChangeFilters(filters) {},
    onClearFilter(name) {
      return () => {};
    },
    onClearFilters(_) {},
    onGetSelectedFilter(_) {
      return undefined;
    },
    onSelected(_) {
      return (__) => {};
    },
    onSyncFilters(filters) {},
    filtersHasValues: false,
    onCheckFiltersHasValues(_filters) {
      return false;
    },
    isUseResponseOptions: false,
  });

export interface FilterHandleComponentProviderProps {
  children: React.ReactNode;
  filters: Filter[];
  setFilters: React.Dispatch<React.SetStateAction<Filter[]>>;
  isUseResponseOptions?: boolean;
}

export function FilterHandleProvider(
  props: FilterHandleComponentProviderProps,
) {
  const { filters, setFilters, isUseResponseOptions = false } = props;
  const handler = useFilterHandleTransformer(filters, setFilters);

  return (
    <FilterHandleComponentContext.Provider
      value={{ ...handler, isUseResponseOptions }}
    >
      {props.children}
    </FilterHandleComponentContext.Provider>
  );
}

export default function useFilterHandleComponent() {
  return React.useContext(FilterHandleComponentContext);
}
